import React from "react";
import { TripAdvisorReviewsConnectorProps } from "./container";
import { Box, Typography } from "@material-ui/core";
import { RouteComponentProps } from "react-router";
import "./styles.scss";
import {
  HotelTripAdvisorReviews,
  getCancellationPolicyInfo,
  getCancellationPolicyInfoV2,
} from "halifax";
import clsx from "clsx";
import * as textConstants from "./textConstants";
import { useInView } from "react-intersection-observer";
import { LodgingData, CancellationReason } from "redmond/build/hotels-module";
import {
  useExperiments,
  getExperimentVariant,
  HOTELS_CANCELLATION_POLICY_EXPERIMENT,
  AVAILABLE,
} from "../../../../context/experiments";

export interface TripAdvisorReviewsProps
  extends TripAdvisorReviewsConnectorProps,
    RouteComponentProps {
  lodgingData: LodgingData;
}

export const TripAdvisorReviews = (props: TripAdvisorReviewsProps) => {
  const { lodgingData, cheapestProduct, cancellationSummary } = props;
  const [reviewsRef] = useInView({ threshold: 0.8 });
  const expState = useExperiments();

  const cancellationPolicyInfo = cheapestProduct?.cancellationPolicyV2
    ? getCancellationPolicyInfoV2(cheapestProduct?.cancellationPolicyV2)
    : cheapestProduct?.cancellationPolicy
    ? getCancellationPolicyInfo(
        cheapestProduct?.cancellationPolicy,
        textConstants.getCfarSecondaryText
      )
    : null;

  const isCancellationPolicyExperimentAvailable =
    getExperimentVariant(
      expState.experiments,
      HOTELS_CANCELLATION_POLICY_EXPERIMENT
    ) === AVAILABLE;

  const isCaliforniaHotel = cancellationSummary?.reasons.includes(
    CancellationReason.CaliforniaBill644
  );

  const shouldShowCancellationPolicy =
    (!isCancellationPolicyExperimentAvailable || isCaliforniaHotel) &&
    cancellationPolicyInfo?.className !== "free-cancellation";

  return (
    <div
      className={clsx("section-wrapper reviews-and-cancellation-section")}
      id="reviews-section"
      ref={reviewsRef}
    >
      <Typography variant="h2">{textConstants.REVIEWS}</Typography>
      <HotelTripAdvisorReviews lodgingData={lodgingData} trim={1000} />
      {cancellationPolicyInfo && shouldShowCancellationPolicy && (
        <Box className={clsx("section-wrapper", "cancellation-policy-section")}>
          <Typography
            variant="h4"
            className="hotel-shop-cancellation-policy-heading"
          >
            {cancellationPolicyInfo.primaryText}
          </Typography>
          <Typography variant="subtitle2">
            {cancellationPolicyInfo.secondaryText}
          </Typography>
        </Box>
      )}
    </div>
  );
};
